import { useContext } from 'react';
import GameContext from 'contexts/game';

export default () => (
    useContext(GameContext)
);
